<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.17</b> - *НАКОНЕЦ-ТО* Пещеры перестали течь (наверное)</p>
    <div class="ml-5 pb-4 text-violet-300">
      <div class="font-bold mt-2">Производительность</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлены множественные утечки памяти в Пещерах, включая объекты отображения, поиск пути
          ИИ, состояния юнитов, записи журнала боя и многое другое!
        </li>
        <li>Переход на растровые шрифты (меньше нагрузка на процессор) для всплывающего текста.</li>
      </ul>

      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>
          Ячейки снаряжения теперь имеют фон и подсказки, когда пусты, указывая, какой тип
          экипировки принадлежит каждой ячейке.
        </li>
        <li>
          Полоски характеристик героев в Пещерах теперь анимируются при потере ОЗ или трате ОД/МС.
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>
          Свечи теперь правильно истекают при входе в игру или выходе из экранов боя, а истёкшие
          свечи больше не отображаются в Храме.
        </li>
      </ul>
    </div>
  </div>
</template>
